// src/pages/PublicCatalog/styles.js
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '100vh',
        backgroundColor: theme.palette.grey[100],
    },
    appBar: {
        backgroundColor: theme.palette.primary.main,
    },
    toolbar: {
        display: 'flex',
        justifyContent: 'space-between',
        maxWidth: 1200,
        width: '100%',
        margin: '0 auto',
    },
    floatingCartButton: {
        position: 'fixed',
        bottom: theme.spacing(3),
        right: theme.spacing(3),
        zIndex: 1100,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: theme.palette.primary.dark,
        },
        [theme.breakpoints.down('sm')]: {
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        },
        display: 'none', // Initially hidden on larger screens
        [theme.breakpoints.down('sm')]: {
          display: 'flex', // Show on mobile
        },
      },
    searchBar: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        position: 'sticky',
        top: 64,
        zIndex: 1,
        [theme.breakpoints.down('sm')]: {
            top: 56,
            padding: theme.spacing(1),
        },
    },
    searchContainer: {
        display: 'flex',
        gap: theme.spacing(2),
        flexWrap: 'wrap',
        [theme.breakpoints.down('sm')]: {
            gap: theme.spacing(1),
        },
    },
    searchInput: {
        flex: 1,
        minWidth: 200,
    },
    title: {
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            fontSize: '1.2rem',
        },
    },
    container: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(4),
    },
    loading: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '50vh',
    },
    noProducts: {
        textAlign: 'center',
        padding: theme.spacing(4),
    }
}));